import { Box, BoxProps, Spinner, SpinnerProps } from '@chakra-ui/react';

export const WrappedSpinner = ({ size, ...props }: BoxProps & Pick<SpinnerProps, 'size'>) => (
  <Box textAlign="center" {...props}>
    <Spinner size={size} />
  </Box>
);
